import React from "react";
import useSWR from "swr";
import { useAuth } from "@/context/AuthContext";
import api, { money } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import StatusBadge from "@/components/StatusBadge";

const fetcher = (u) => api.get(u).then((r) => r.data);

export default function ClientPortal() {
  const { user } = useAuth();
  const { data: parts } = useSWR("/participants", fetcher);
  const me = (parts || []).find((p) => p.email?.toLowerCase() === user?.email?.toLowerCase());
  const { data: pays } = useSWR(me ? `/payments?participant_id=${me.id}` : null, fetcher);
  const { data: tours } = useSWR("/tours", fetcher);
  const tour = tours?.find((t) => t.id === me?.tour_id);

  const paid = (pays || []).reduce((s, p) => s + (p.is_refund ? -p.amount : p.amount), 0);
  const total = me?.price || tour?.price_per_participant || 0;
  const pending = Math.max(0, total - paid);

  return (
    <div className="space-y-6">
      <div><h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Mi Expedición</h1><p className="text-slate-500 mt-1">Portal privado de participante.</p></div>
      {!me ? (
        <Card><CardContent className="p-10 text-center text-slate-500">
          No encontramos una reserva asociada a <span className="mono">{user?.email}</span>. Contacta con IceMonkey para vincular tu cuenta.
        </CardContent></Card>
      ) : (
        <>
          <Card><CardContent className="p-5">
            <div className="flex items-start justify-between flex-wrap gap-3">
              <div>
                <div className="text-xs mono uppercase text-slate-500">Tour reservado</div>
                <div className="text-xl font-bold mt-1">{tour?.name || "—"}</div>
                <div className="text-sm text-slate-500">{tour?.destination}, {tour?.country} · {tour?.start_date} → {tour?.end_date}</div>
              </div>
              <StatusBadge value={me.booking_status} />
            </div>
          </CardContent></Card>

          <div className="grid md:grid-cols-3 gap-4">
            <Card><CardContent className="p-4"><div className="text-xs mono uppercase text-slate-500">Precio total</div><div className="text-xl font-bold mt-1">{money(total)}</div></CardContent></Card>
            <Card><CardContent className="p-4"><div className="text-xs mono uppercase text-slate-500">Pagado</div><div className="text-xl font-bold mt-1 text-emerald-600">{money(paid)}</div></CardContent></Card>
            <Card><CardContent className="p-4"><div className="text-xs mono uppercase text-slate-500">Pendiente</div><div className="text-xl font-bold mt-1 text-amber-600">{money(pending)}</div></CardContent></Card>
          </div>

          <Card className="overflow-hidden"><CardHeader><CardTitle>Historial de pagos</CardTitle></CardHeader><CardContent className="p-0 overflow-x-auto">
            <table className="w-full text-sm min-w-[520px]">
              <thead className="bg-slate-100 dark:bg-[#1A2336]"><tr><th className="text-left px-4 py-3">Fecha</th><th className="text-left px-4 py-3">Tipo</th><th className="text-left px-4 py-3">Método</th><th className="text-right px-4 py-3">Importe</th></tr></thead>
              <tbody>
                {(pays || []).map((p) => (
                  <tr key={p.id} className="border-t border-slate-100 dark:border-[#25334D]/50">
                    <td className="px-4 py-3 mono">{p.date}</td>
                    <td className="px-4 py-3">{p.kind}</td>
                    <td className="px-4 py-3 text-slate-500">{p.method}</td>
                    <td className="px-4 py-3 text-right mono">{money(p.amount, p.currency)}</td>
                  </tr>
                ))}
                {(!pays || pays.length === 0) && <tr><td colSpan={4} className="text-center py-8 text-slate-500">Aún no hay pagos registrados.</td></tr>}
              </tbody>
            </table>
          </CardContent></Card>
        </>
      )}
    </div>
  );
}
